import styled from 'styled-components'
import colors from 'Assets/colors'
import { media } from 'Config/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 600px;
  ${media('lg')} {
    width: 100%;
  }
`

export const Content = styled.div`
  background: colors.white;
  width: 600px;
  align-items: flex-start;
  justify-content: center;
  height: 400px;
  margin-bottom: 20px;
  ${media('lg')} {
    width: 100%;
  }
`

export const Title = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.black};
  text-align: center;
  margin-top: 20px;
`

export const LabelTitle = styled.div`
  font-family: Inter;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  margin-bottom: 16px;
  margin-top: 16px;

  text-align: left;
`

export const ConfirmButton = styled.div`
  width: 100%;
  background-color: ${colors.secondary};
  padding: 1rem;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.white};
  border: 2px solid ${colors.secondary};
  border-radius: 8px;
  cursor: pointer;
  align-items: center;
  transition: all 0.2s;
  margin-bottom: 12px;

  &:hover {
    opacity: 0.8;
    transform: translateY(-2px);
    box-shadow: 0 3px 5px rgba(51, 51, 51, 0.2);
  }

  &:active {
    transform: translate(-1px);
    box-shadow: 0 1px 3px rgba(51, 51, 51, 0.4);
  }

  &[disabled] {
    pointer-events: none;
    opacity: 0.6;
  }
`
export const CancelContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  padding-bottom: 16px;
`

export const CancelTitle = styled.h2`
  font-size: 24px;
  font-weight: 400;
  color: #333;
  margin-bottom: 24px;
`

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const SelectButton = styled.button`
  width: 100%;
  height: 56px;
  background-color: white;
  border: 0.5px solid #d1d5db;
  border-radius: 8px;
  padding: 16px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: border-color 0.2s ease;
  font-size: 16px;

  &:hover {
    border-color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`

export const SelectText = styled.span`
  color: ${props => (props.$hasValue ? '#1f2937' : '#6b7280')};
  font-size: 16px;
`

export const ArrowIcon = styled.svg`
  width: 20px;
  height: 20px;
  color: #6b7280;
  transition: transform 0.2s ease;
  transform: ${props => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export const DropdownMenu = styled.div`
  position: absolute;
  z-index: 10;
  width: 100%;
  margin-top: 8px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`

export const OptionButton = styled.button`
  width: 100%;
  padding: 16px;
  text-align: left;
  font-size: 16px;
  color: #1f2937;
  background-color: white;
  border: none;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9fafb;
  }

  &:focus {
    outline: none;
    background-color: #f3f4f6;
  }
`
